<template>
  <div class="content">
    <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>Vlog</p>
    </div>
    <el-form>
        <el-form-item label='vlog名稱 :'>
            <input maxlength="256" class="el-input__inner" type="text" v-model="data.diaryName">
        </el-form-item>
    <el-form-item label="新聞版塊 :"  >
        <el-select v-model="data.diaryType" disabled placeholder="">
            <el-option label="vlog" value="2"></el-option>
        </el-select>
    </el-form-item>

    <el-form-item label="定時發佈 ：">
      <el-switch
        active-color="#6C3DEA"
        v-model="data.timingFlag">
      </el-switch>
    </el-form-item>

    <el-form-item v-show="data.timingFlag" label="發佈時間 :">
        <el-date-picker v-model="data.publishTime" type="datetime" placeholder="選擇時間"></el-date-picker>
    </el-form-item>

    <!-- <el-form-item label='新聞類別 :'>
        <input maxlength="10" class="payResult normal_font" type="text" value="會員">
    </el-form-item> -->
    <!-- <el-form-item label="新聞類別 ：" v-if="type==='add'">
      <el-radio-group v-model="userLayout">
          <el-radio :label="1">VIP用戶</el-radio>
          <el-radio :label="2">僅測試人員</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="新聞類別 ：" v-else>
      <p class="blackColor" v-if="userLayout===1">VIP用戶</p>
      <p class="blackColor" v-else>僅測試人員</p>

    </el-form-item> -->
        <!-- :on-success='successImage' -->
    <el-form-item label="上傳封面 :" class="picupload">
        <el-upload
        action=''
        :http-request='uploadRequest'
        :with-credentials= "true"
        :headers="{'Authorization': this.$cookie.get('auth')}"
        :data="uploadData"
        :on-error ='$errorImage'
        :before-upload="beforePicUpload"
        :on-exceed="$handleExceed.bind(this, 1)"
        :on-remove="handleRemove"
        :on-progress="uploadImgProcess"
        :file-list="mainPictureUrl"
        :limit= 1
        accept=".jpg,.jpeg,.png,.tif,.tiff"
        :multiple='false'
        name= 'multipartFile'
        list-type="picture-card">
        <el-button v-if="!imgFlag" size="small" type="primary">選擇圖片</el-button>
        <div slot="tip" class="el-upload__tip">支持jpg/png/tif格式</div>
        <el-progress v-if="imgFlag" type="circle" :percentage="imgUploadPercent" style="margin-top:10px;"></el-progress>
        </el-upload>
    </el-form-item>

    <el-form-item label="上傳影片 :">
        <video width="80%" v-if="VideoUrl.length==1" class="avatar" :src="VideoUrl[0].url" controls="controls">您的浏览器不支持视频播放</video>
        <span style="cursor: pointer;"  @click="handleVideoRemove()" v-if="VideoUrl.length == 1">刪除</span>
        <el-upload
          action=''
          :http-request='uploadRequest'
          :with-credentials= 'true'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :data="uploadData"
          :on-error ='errorVideo'
          :on-exceed="handleVideoExceed"
          :on-remove="handleVideoRemove"
          :on-progress="uploadVideoProcess"
          :file-list="VideoUrl"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
          :limit= 1
          accept= ".mp4"
          :multiple='false'
          name= 'multipartFile'
          list-type="picture-card">
          <el-button v-if="!videoFlag" size="small" type="primary">選擇視頻</el-button>
          <div slot="tip" class="el-upload__tip">支持mp4格式</div>
          <el-progress v-if="videoFlag" type="circle" :percentage="videoUploadPercent" style="margin-top:10px;"></el-progress>
        </el-upload>
    </el-form-item>

    <div class="editor-wrap">
        <p class="editor-title">圖文詳情 :</p>
        <Editor style="color:#fff;" @listenContent='getContent' :content='content' :colorFlag = true :newsFlag='true'></Editor>
    </div>
    </el-form>
    <div class="bottomBtn mobileBtn" >
        <div class="btn new_btn" @click="previewNews()">查看預覽</div>
        <div class="btn new_btn" @click="submitVlog()">發佈</div>
    </div>
    <!--发布预览-->
    <div v-if="previewFlag" class="propWrap">
      <div class="prop-content mobile_show">
        <div class="closeWrap" @click="closeProp()">
            <i class="iconfont icon-close fr" ></i>
        </div>
        <p class="prop-title">查看vlog預覽</p>
        <div class="previewMain">
            <img class="previewBg" src="@/assets/images/common/vlogPreview.png" alt="">
            <div class="newsContent">
              <div class="previewTop">
                <div class='headWrap'>
                  <img src="@/assets/images/common/bangong.png" alt="">
                </div>
                <div class="infoWrap">
                  <p style="color:#fff;font-size:0.12rem;">小版工</p>
                  <p style="color:rgba(255,255,255,0.6);font-size:0.10rem;">{{releaseTime}}</p>
                </div>
              </div>
              <div class="newsMain">
                <img class="newsMainImg" :src="mainImage" alt="">
                <div class="newsWrap">

                  <div class="mobile_img">
                    <div class="vip-icon">
                      <img src="@/assets/images/common/vipIcon.png" alt="">
                    </div>
                    <div class="newsText ell">{{newsTitle}}</div>
                  </div>

                  <p class="interact">0 讚 • 0 評論</p>
                </div>

              </div>
            </div>
        </div>
        <div class="bottomBtn">
          <div class="btn new_btn" @click="closeProp()">確認</div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import Editor from '@/components/editor';
import fileUtils from '@/utils/fileUtils.js';
import DiaMess from '@/components/dialog';

export default {
  props: ['type','id'],
  data () {
    return {
      previewFlag:false,
      navtitle:'新聞/vlog',
      mainPictureUrl:[],
      VideoUrl: [],
      videoCdnFlag: true,
      cdnText:'預熱',
      data:{
        diaryName:'',
        diaryType:'2',
        publishTime: '',
        timingFlag: false,//定時發佈
      },
      content: '',
      mainImage: '',
      newsTitle: '',
      releaseTime: '',
      require: true,  // 禁止用户连续点击发出多次请求接口
      uploadData: { // 上传图片的附加参数
        flag: 'xw'
      },
      videoUploadPercent: '',
      videoFlag: false,
      userLayout: 1, //新聞類別
      originalPublishTime:'',// 原始发布时间
      originalTimeFlag: null,// 原始是否定时发布
      pushTaskId:'',
      originalVideoUrl: '',//原始视频url
      imgFlag: false,
      imgUploadPercent: 0,
      dialogVisible: false,
    }
  },
  created(){
    let _this = this;
    if (_this.type === 'edit') {
      _this.getvlogDetails();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 编辑vlog详情
    getvlogDetails(){
      let _this = this;
      _this.$get(`/request/article/getArticleDetail/${_this.id}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            let timeFormat = _this.$compareTime(res.data.publishDate, new Date());
            console.log(timeFormat)
            if (res.data.publishDate === null || res.data.publishDate === '' || timeFormat === false) {
              // 如果没有publishDate，或者publishDate的时间是过去时间，则为即时发布
              _this.data.timingFlag = false; // 即时发布
              _this.originalTimeFlag = false;
            } else {
              // 否则为定时发布
              _this.data.timingFlag = true; // 定时发布
              _this.originalTimeFlag = true;
            }

            _this.originalPublishTime = res.data.publishDate;//存放原始发布时间
            _this.data.diaryName = res.data.title;
            _this.data.publishTime= res.data.publishDate;
            _this.content = res.data.context;
            _this.data.type = res.data.type;
            _this.userLayout = res.data.oriType
            if(res.data.vlogUrl != null){
              _this.VideoUrl.push({name:'video.mp4', url:res.data.vlogUrl});
              _this.originalVideoUrl = res.data.vlogUrl;
              document.getElementsByClassName('el-upload')[1].style.display = 'none';
            }
            _this.mainPictureUrl.push({name: 'img.jpg', url: res.data.primaryPictureUrl});
            document.getElementsByClassName('el-upload')[0].style.display = 'none';

          } else {
            _this.$propMessage(res.message, 'error');
          }
        });
    },
    // 上传图片
    successImage (res, file) {
      let _this = this;
      _this.mainPictureUrl.push({url: res.msg}); // 展示图片
      document.getElementsByClassName('el-upload')[0].style.display = 'none';
    },
    beforePicUpload(file) {
      let _this = this;
      return new Promise((resolve) => {

        if (file.type === 'image/tiff') {
          resolve(file);
        } else {
          fileUtils.getOrientation(file).then((orient) => {

            if (orient && orient === 6) {
              let reader = new FileReader();
              let img = new Image();
              reader.onload = (e) => {
                img.src = e.target.result;
                img.onload = function () {
                  if (img.height > 3000 || file.size > 1024*1024*2) {
                    _this.$imageConversion.compress(file, {
                      quality: 0.3,
                      height: 3000
                    }).then(res =>{
                      const data = fileUtils.rotateImage(img, img.width, img.height);
                      const newFile = fileUtils.dataURLtoFile(data, file.name);
                      resolve(newFile);
                    })
                  }  else {
                    const data = fileUtils.rotateImage(img, img.width, img.height);
                    const newFile = fileUtils.dataURLtoFile(data, file.name);
                    resolve(newFile);
                  }
                }
              }
              reader.readAsDataURL(file);
            } else {
              let _URL = window.URL || window.webkitURL;
              let img = new Image();
              img.onload = function () {
                if (img.width > 3000 || file.size > 1024*1024) {
                  _this.$imageConversion.compress(file, {
                    quality: 0.3,
                    width: 3000
                  }).then(res =>{
                    resolve(res);
                  })
                } else {
                  resolve(file);
                }
              }
              img.src = _URL.createObjectURL(file);
            }
          });
        }

      });
    },
    handleRemove(file) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.mainPictureUrl);
      _this.$Mint.Toast({message: '刪除成功'});
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
      return false;
    },
    // 上传视频
    uploadRequest(option){
      console.log(option)
      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        let fileWay = ''
        if (extensionName === '.mp4' || extensionName === '.MP4' || extensionName === '.Mp4' || extensionName === '.mP4') {
          fileWay = 'resource/video/'
        } else {
          fileWay = 'resource/image/'
        }
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        console.log(fileName)
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function(p) {
              if(extensionName === '.mp4' || extensionName === '.MP4' || extensionName === '.Mp4' || extensionName === '.mP4'){
                if(p>0){
                  self.videoFlag = true
                } else if(p=1){
                  self.videoFlag = false
                }
                self.videoUploadPercent =  Math.floor(p * 100)
              } else {
                if(p > 0){
                  self.imgFlag = true
                } else if(p = 1){
                  self.imgFlag = false
                }
                self.imgUploadPercent =  Math.floor(p * 100)
              }
            },
            headers:{'Cache-Control':'public'}
          }).then((val) => {
            if (val.res.statusCode === 200) {
              if(extensionName === '.mp4' || extensionName === '.MP4' || extensionName === '.Mp4' || extensionName === '.mP4'){
                self.VideoUrl.push({name:'video.mp4', url: self.$GLOBAL.picFileUrl + val.name})

                document.getElementsByClassName('el-upload')[1].style.display = 'none';
                //cdn预热
                // self.$cdnFun(self.VideoUrl[0].url).then(res=>{
                //   this.pushTaskId=res.data.pushTaskId
                // })
                self.$convertVideo(val.name).then(res=>{
                  console.log(res)
                })
              } else {
                self.mainPictureUrl.push({url: self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic}); // 展示图片
                  console.log('图片路径'+self.mainPictureUrl[0].url)

                //cdn预热
                self.$cdnFun(self.mainPictureUrl[0].url).then(res=>{
                  console.log(res)

                })
                document.getElementsByClassName('el-upload')[0].style.display = 'none';
              }
              return val
            } else {
              option.onError('上传失败1')
            }
          }, err => {
            console.log(err)
            option.onError('上传失败')
            reject(err)
          })
        })
      })
    },
    errorVideo () {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage('上傳失敗！請重新登錄','error',function(){
        _this.dialogVisible = false;
      });
    },
    handleVideoExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage('最多上傳一個視頻','error',function(){
        _this.dialogVisible = false;
      });
      return false;
    },
    beforeVideoUpload(file) {
      let _this = this;
      // const isVideo = file.type === 'video/mp4' || 'video/3gp' || 'video/3gpp' || 'video/rm' || 'video/rmvb' || 'video/avi' || 'video/wmv' || 'video/mov';
      const isVideo = file.type === 'video/mp4';
      // const isLt2GB = file.size / 1024 / 1024 < 10240;
      if (!isVideo) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳視頻格式不正確','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };
      // if (!isLt2GB) {
      //   _this.$Mint.Toast('上傳視頻大小不能超過10GB!');
      //   return false;
      // };
    },
    handleVideoRemove(file) {
      let _this = this;
      _this.VideoUrl =[]
      _this.videoFlag = false;
      _this.$Mint.Toast({message: '刪除成功'});
      document.getElementsByClassName('el-upload')[1].style.display = 'inline-block';
      return false;
    },
    // 视频上传进度条
    uploadVideoProcess(event, file, fileList){
      console.log(event)
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0);
    },
    // 图片上传进度条
    uploadImgProcess(event, file, fileList){
      this.imgFlag = true;
      this.imgUploadPercent = Number(file.percentage.toFixed(0));
    },
    closeProp(){
      let _this = this;
      _this.previewFlag = false;
    },
    // 预览模式
    previewNews(){
      let _this = this;
      if (_this.data.diaryName === '') {
        _this.dialogVisible = true;
        _this.$propMessage('vlog名稱不能爲空','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      if (_this.mainPictureUrl.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('視頻封面不能爲空','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
      _this.previewFlag = true;
      _this.mainImage = _this.mainPictureUrl[0].url;
      _this.newsTitle = _this.data.diaryName;
      _this.releaseTime = date;
    },
    // 发布
    submitVlog() {
      let _this = this;
      if (_this.data.diaryName === '') {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入vlog名稱','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };

      if (_this.$getCaption(_this.data.diaryName)) {
        _this.dialogVisible = true;
        _this.$propMessage('vlog名稱不能含有非法字符','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      }

      if ((_this.data.publishTime === null || _this.data.publishTime === '') && _this.data.timingFlag) {
        _this.dialogVisible = true;
        _this.$propMessage('發佈時間不能為空','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.mainPictureUrl.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇視頻封面','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };

      if (_this.VideoUrl.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇上傳影片','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };

      // if(_this.type==='add' || (_this.type==='edit' && _this.originalVideoUrl!==_this.VideoUrl[0].url)){
      //   _this.$checkCdnProgress(_this.pushTaskId).then(res=>{
      //     if(res.data.tasks[0].process!='100%'){
      //       _this.videoCdnFlag = false
      //     } else{
      //       _this.videoCdnFlag = true
      //     }
      //   })
      // }

      _this.$confirm('是否確認發佈該新聞', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(() => {
          // 確認發佈
          if (_this.require === true) {

            _this.require = false;
            let time, status, publishTime;
            let timeFormat = _this.$compareTime(_this.data.publishTime, new Date());

            if (timeFormat === false && _this.data.timingFlag) {
              //发布时间是过去的时间并且设置定时发布

              status = 1; //即时发布
              time = typeof(_this.data.publishTime) === 'string'? _this.data.publishTime : _this.$formatDate(_this.data.publishTime);
            } else {
              publishTime = typeof(_this.data.publishTime) === 'string'? _this.data.publishTime : _this.$formatDate(_this.data.publishTime)
              // 如果一开始是定时发布，点击发布时是即时发布
              if(_this.originalTimeFlag == true && _this.data.timingFlag == false) {
                time = _this.$formatDate(new Date())
              } else{
                // 定时发布的为publishTime,即时发布为现在时间
                time = _this.data.timingFlag ? publishTime : _this.$formatDate(new Date());

              }
              status = _this.data.timingFlag ? 2:1;
            }
            if(_this.type === 'edit') {
              let param = {
                  id: _this.id,
                  title: _this.data.diaryName,
                  type: _this.data.diaryType,
                  // publishDate: time,
                  primaryPictureUrl: _this.mainPictureUrl[0].url,
                  vlogUrl:_this.VideoUrl[0].url,
                  context: _this.content,
                  status: status,
              };
              if (_this.originalPublishTime == publishTime){
                  if(_this.originalTimeFlag == true && _this.data.timingFlag == false) {
                    param.publishDate = time
                  } else{
                    param.updateDate = publishTime
                  }
              } else {
                param.publishDate = time
              }
              console.log(param)

              _this.$post('/request/article/editArticle', param, _this.$GLOBAL.jsonConfig)
                .then((res) => {
                  _this.dialogVisible = true;
                  if (res.code === '00000') {
                    _this.closeProp();
                    _this.$propMessage('编辑Vlog成功', 'success',
                      function(){
                        _this.dialogVisible = false;
                        _this.$router.push('/newsVlog');
                      });
                  }
                  else if (res.code ==='40002') {
                    if(res.data === '包含非法字符') {
                      _this.$propMessage('輸入內容不能包含非法字符，請重試', 'error',
                        function(){
                        _this.dialogVisible = false;
                      });
                    } else {
                      _this.$propMessage(res.message, 'error',
                        function(){
                        _this.dialogVisible = false;
                      });
                    }
                  }
                  else{
                    _this.$propMessage(res.message, 'error',
                      function(){
                        _this.dialogVisible = false;
                      });
                  };
                });
            } else if (_this.type==='add') {
              let param ={
                title: _this.data.diaryName,
                type: _this.data.diaryType,
                publishDate: time,
                primaryPictureUrl: _this.mainPictureUrl[0].url,
                vlogUrl: _this.VideoUrl[0].url,
                context: _this.content,
                status: status,
                // oriType: _this.userLayout
              };
              _this.$post('/request/article/addArticle', param, _this.$GLOBAL.jsonConfig)
                .then((res) => {
                  _this.dialogVisible = true;
                  if (res.code === '00000') {
                    _this.closeProp();
                    _this.$propMessage('新增Vlog成功', 'success',
                    function(){
                        _this.dialogVisible = false;
                        _this.$router.push('/newsVlog');
                      });
                  }
                  else if (res.code ==='40002') {
                    if(res.data === '包含非法字符') {
                      _this.$propMessage('輸入內容不能包含非法字符，請重試', 'error',
                        function(){
                          _this.dialogVisible = false;
                        });
                    } else {
                      _this.$propMessage(res.message, 'error',
                        function(){
                          _this.dialogVisible = false;
                        });
                    }
                  }
                  else {
                    _this.$propMessage(res.message, 'error',
                      function(){
                        _this.dialogVisible = false;
                      });
                  };
                });
            }
          }
          setTimeout(() => {
            _this.require=true;
          },5000)
        })
        .catch(() => {
        });
    },
    //图文详情
    getContent(data){
      this.content = data;
    },
  },
  components: {
    Editor,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .paddingContent{
      padding-bottom: 40px;

      @media (max-width: 420px) {
        padding-bottom: 25px;
      }

    }
    .previewMain{
        width: 2rem;
        height: 4.2rem;
        margin:0 auto;
        position: relative;
        .previewBg{
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index:1;
        }
        .newsContent{
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            .previewTop{
                padding:0 0.08rem;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-top: 0.8rem;

              @media (max-width: 420px) {
                padding:0 0.15rem;
                margin-top: 95px;
              }

                .headWrap{
                  position: relative;
                    width: 20px;
                  height: 20px;
                    border-radius: 50%;

                  &:after {
                    position: absolute;
                    content: '';
                    top: -8px;
                    left: 12px;
                    width: 12px;
                    height: 12px;
                    background-image: url("../assets/images/common/icon_huangguan.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                  }

                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                    }
                }
                .infoWrap{
                    padding-left: 6px;
                    p{
                        text-align: left;
                    }
                }

            }
            .newsMain{
                width: 1.56rem;
                height: 1.56rem;
                border-radius: 0.1rem;
              margin: 0.06rem 0;
              margin-left: 35px;
                overflow: hidden;
                position: relative;

              @media (max-width: 420px) {
                width: 3.08rem;
                height: 3.08rem;
                border-radius: 0.2rem;
                margin: 0.1rem 0;
                margin-left: 35px;
              }

                .newsMainImg{
                    display: block;
                    width: 1.56rem;
                    height: 1.56rem;
                    overflow: hidden;
                    position: absolute;
                    top: 0;
                    left:0;
                    z-index: 20;

                  @media (max-width: 420px) {
                    width: 3.08rem;
                    height: 3.08rem;
                  }

                }
                .newsWrap{
                  background: linear-gradient(bottom,rgba(0,0,0,0.5),rgba(0,0,0,0));
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index:99;
                    width: 100%;
                    height: 50%;
                  border-radius: 0.1rem;
                    padding: 0 0.08rem;
                    display:flex;
                    align-items: flex-end;

                  @media (max-width: 420px) {
                    border-radius: 0.2rem;
                    padding: 0 0.2rem;
                  }

                    .vip-icon{
                      margin-top: 3px;
                        width: 20px;
                        height: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-top-left-radius: 0.05rem;
                        border-bottom-right-radius: 0.05rem;
                        background: -webkit-linear-gradient(150deg,rgba(190,162,117,1),rgba(237,223,190,1)); /* Safari 5.1 - 6.0 */
                        background: -o-linear-gradient(150deg,rgba(190,162,117,1),rgba(237,223,190,1)); /* Opera 11.1 - 12.0 */
                        background: -moz-linear-gradient(150deg,rgba(190,162,117,1),rgba(237,223,190,1)); /* Firefox 3.6 - 15 */
                        background: linear-gradient(150deg,rgba(190,162,117,1),rgba(237,223,190,1)); /* 标准的语法 */

                      @media (max-width: 420px) {
                        width: 35px;
                        height: 10px;
                      }

                        img{
                            width: 80%;

                          @media (max-width: 420px) {
                            width: 85%;
                          }

                        }
                    }
                    .totop{
                        width:0.5rem;
                        height: 0.15rem;
                        margin-left: 0.08rem;
                        font-size: 0.08rem;
                        color: #fff;
                        border-top-left-radius: 0.05rem;
                        border-bottom-right-radius: 0.05rem;
                        font-weight: bold;
                        font-style: italic;
                        background: -webkit-linear-gradient(-90deg,rgba(171,96,255,1),rgba(105,56,223,1)); /* Safari 5.1 - 6.0 */
                        background: -o-linear-gradient(-90deg,rgba(171,96,255,1),rgba(105,56,223,1)); /* Opera 11.1 - 12.0 */
                        background: -moz-linear-gradient(-90deg,rgba(171,96,255,1),rgba(105,56,223,1)); /* Firefox 3.6 - 15 */
                        background:linear-gradient(-90deg,rgba(171,96,255,1),rgba(105,56,223,1));
                    }
                    .newsText{
                        color: #fff;
                        font-size: 0.1rem;
                      margin-left: 6px;
                      line-height: 15px;
                      text-align: left;
                      width: 86%;

                      @media (max-width: 420px) {
                        font-size: 12px;
                      }

                    }

                }
                .interact{
                    position: absolute;
                    z-index: 99;
                    bottom: 0.06rem;
                    right: 0;
                    padding: 0 0.08rem;
                    color: rgba(255,255,255,0.5);
                    font-size:0.1rem;

                  @media (max-width: 420px) {
                    bottom: 0.1rem;
                    padding: 0 0.18rem;
                  }

                }
            }
        }
    }

    .mobile_img {
      display: flex;
      justify-content: flex-start;
      padding-bottom: 25px;
    }

    .tips_font {
      font-size: 16px;
      color: #101010;
      padding: 15px 10px;

      @media (max-width: 420px) {
        font-size: 14px;
      }

    }

    .el-input__inner,.prop-title {
      color: #666666;
    }

    .btn {
      cursor: pointer;
    }

    //适配手机端
    .mobile_show {
      @media (max-width: 420px) {
        height: 80%;
        top: 45%;
      }
    }

    .previewMain {
      @media (max-width: 420px) {
        width: 60%;
        height: 80%;
      }
    }

    .previewBg {
      @media (max-width: 420px) {
        height: 100%;
      }
    }

    .el-select {
      width: 100%;
    }

    .mobileBtn {
      @media (max-width: 420px) {
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/vlog.vue